import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchDynamicUsersDetails, updateDynamicUserDetails, userOnboardService } from "../../services/user/userOnboardService";
import { readFromLocalStorage } from "../../utils/DataEncryption";


export const fetchUserOnboardingFeildsAsync = createAsyncThunk(
  "staff/PendingStaffList",
  async (thunkAPI) => {
    const data = {
      "appId":readFromLocalStorage("appId") || process.env.REACT_APP_APPID
  }
    // Add thunkAPI as the second argument
    const response = await userOnboardService(data);
    return response;
  }
);


export const fetchDynamicUserDetailsAsync = createAsyncThunk(
  'user/fetchDynamicUsersDetails',
  async (userId: string, thunkAPI) => {
   const data = {
    "appId":readFromLocalStorage("appId") || process.env.REACT_APP_APPID,
    "userId": userId
    }
    const response = await fetchDynamicUsersDetails(data);
    return response;
  }
);

export const updateDynamicUserDetailsAsync = createAsyncThunk(
  'user/updateUserDetails',
  async ({ data, userId }: { data: any; userId: any }, thunkAPI) => {
    const response = await updateDynamicUserDetails(data,userId);
    return response;
  }
);
